export default {
  getItem(item) {
    return (
      item &&
      localStorage.getItem(`$$${item}`) &&
      JSON.parse(localStorage.getItem(`$$${item}`))
    );
  },
  setItem(key, value) {
    return key && localStorage.setItem(`$$${key}`, JSON.stringify(value));
  },
};
